/* «Партнёр». Оболочка — экран React: колонка #partner и пустые листы.
   Колонку отдаёт prepare() один раз. Дальше раздел сам меняет узлы, и React этот кадр не перерисовывает.
   Листы внутри страницы, после колонки: их рамка — область раздела, как у прототипа. */
import { useLayoutEffect, useState } from 'react';
import { partnerApi } from './module';
import { uiText, useAccountLocale } from '../../i18n';

/** Пустой лист BotCore: затемнение и панель. Содержимое раздел вставляет сам; подпись — на языке профиля (смена языка перерисовывает) */
function Sheet({ id, label }: { id: string; label: string }) {
  useAccountLocale();
  return (
    <>
      <div className="bscrim" id={`${id}Scrim`} data-bsheet-x="" />
      <aside className="side bsheet" id={id} role="dialog" aria-label={uiText(label)} aria-hidden="true" />
    </>
  );
}

export function Partner() {
  const api = partnerApi();
  const [m] = useState(() => api.prepare());
  useLayoutEffect(() => {
    api.attach();
  }, [api]);
  return (
    <div className="pg stp" id="partner">
      <div className="stp-in" dangerouslySetInnerHTML={{ __html: m.body }} />
      <Sheet id="ptPay" label="Вывод" />
      <Sheet id="ptReel" label="Рилс" />
      <Sheet id="ptTerms" label="Условия программы" />
      <Sheet id="bcSid" label="STEOS ID" />
      <Sheet id="bcStory" label="Сторис в Telegram" />
    </div>
  );
}
